import { LocationListService } from "src/app/services/location-list.service";
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import { WebCustomer } from "src/app/models";
import { CustomerService } from "src/app/services";
import { WebLocation } from "src/app/models";
import { Subscription } from "rxjs";
import { WebCompany } from "../../models";
import { SessionDataService } from "src/app/services/session-data.service";
import { CompanyService } from "../../services";
import { filter } from "rxjs/operators";

@Component({
    selector: "app-location-list",
    templateUrl: "./location-list.component.html",
    styleUrls: ["./location-list.component.scss"],
})
export class LocationListComponent implements OnInit, OnDestroy
{
    title: string = "";
    locationList: WebLocation[];
    locationListSubscription: Subscription;
    @Input() locationId: number;

    customerAddress: string;
    customer: WebCustomer;
    customerSubscription: Subscription;

    company: WebCompany;
    companySubscription: Subscription;
    location: WebLocation;
    isEmployee: boolean = false;

    constructor(
        private customerService: CustomerService,
        private locationService: LocationListService,
        private companyService: CompanyService,
        public sessionDataService: SessionDataService
    ) { }

    ngOnInit()
    {
        this.isEmployee = this.sessionDataService.IsEmployee;
        this.locationListSubscription = this.locationService.locationList.subscribe((e) =>
        {
            if (this.sessionDataService.IsEmployee)
            {
                this.locationList = e;
            } 
            else
            {
                this.locationList = e.filter((loc) => loc.Inactive === false);
            }
        });

        this.customerSubscription = this.customerService.customer
            .pipe(filter((customer) => !!customer))
            .subscribe((customer) =>
            {
                this.customer = customer;
                this.customerAddress =
                    this.customer.Addr1 +
                    " " +
                    this.customer.City +
                    ", " +
                    this.customer.State +
                    " " +
                    this.customer.Zip;
            });

        this.companySubscription = this.companyService.company.subscribe((c) =>
        {
            this.company = c;
        });
    }

    ngOnDestroy()
    {
        this.locationListSubscription.unsubscribe();
        this.customerSubscription.unsubscribe();
        this.companySubscription.unsubscribe();
    }

    allowLocationDetails(): void
    {
        this.isEmployee = this.sessionDataService.IsEmployee;
    }
}
